import { useEffect, useRef, useState } from "react";
import TopLable from "../../../components/comman/TopLable";
import MainHeading from "../../../components/comman/MainHeading";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { MainFilterHandler } from "../../../components/comman/MainFilterHandler";
import { callApi } from "../../../ApiHelper/ApiHelper";
import moment from "moment";
import {
  calculateHours,
  formatTo12HourTime,
  handleAttendanceStatus,
} from "../../../utility/CommonFunctions";
import { toast } from "react-toastify";
import FilterComponent from "../../../components/comman/FilterComponent";
import NoRecordIcon from "../../../components/Icons/NoRecordIcon";
import { useLocation, useParams } from "react-router-dom";
import ExportDataHandler from "../../../utility/ExportDataHandler";
import { updateFiltersStates } from "../../../store/actions/UserActions";
import { useDispatch, useSelector } from "react-redux";

export default function AttendanceUser() {
  const { id } = useParams();
  const location = useLocation();
  const dispatch = useDispatch();
  const filterDetails = useSelector((state) => state.root.filtersStates);
  const [state, setState] = useState({
    attendanceCount: null,
    attendanceList: [],
  });
  const [pageStates, setPageStates] = useState({
    currentPage: 1,
    pageSize: 10,
    count: 0,
    totalPages: 0,
    tableLoader: false,
    filterData: "",
    sortByDate: location?.state?.month || [
      moment().startOf("month").format("YYYY-MM-DD"),
      moment().endOf("month").format("YYYY-MM-DD"),
    ],
    attendanceStatus: "",
    ...(id ? {} : { myAttendance: true }),
  });

  const [filterData, setFilterData] = useState({
    sortByDate: [
      moment().startOf("month").format("YYYY-MM-DD"),
      moment().endOf("month").format("YYYY-MM-DD"),
    ],
  });

  const getMyAttendance = (pageNo) => {
    let options = {
      method: "GET",
    };
    const filterData = {
      ...pageStates,
      orderBy: filterDetails?.orderBy,
    };
    if (id) {
      delete filterData.attendanceStatus;
      delete filterData.filterData;
      // delete filterData.sortByDate
    }
    const Url =
      `${apiUrl.get_attendance}?` +
      MainFilterHandler({ ...filterData, usersId: id ? id : "" });
    setPageStates((pre) => ({
      ...pre,
      tableLoader: !pre.tableLoader,
    }));
    callApi(Url, options).then((res) => {
      setPageStates((pre) => ({
        ...pre,
        tableLoader: !pre.tableLoader,
      }));
      if (res?.status === true) {
        const newData = res?.data?.attendance?.[0]?.attendances?.map(
          (item) => ({
            ...item,
            attendanceDate: moment.utc(item?.checkInTime).format("DD/MM/YYYY"),
            shift: res?.data?.attendance?.[0]?.Shift?.shiftName,
            checkInTime: item?.checkInTime
              ? formatTo12HourTime(item?.checkInTime)
              : "--",
            checkOutTime: item?.checkOutTime
              ? formatTo12HourTime(item?.checkOutTime)
              : "--",
            workingHours: item?.checkOutTime
              ? calculateHours(item?.checkInTime, item?.checkOutTime)
              : "--",
            workType: item?.type === 0 ? "Site" : "Office ",
            attendanceStatus: item ? item?.status : 2,
          }),
        );
        setState((pre) => ({
          ...pre,
          attendanceList:
            res?.data?.attendance[0]?.attendances?.length > 0 ? newData : [],
        }));
        setPageStates((pre) => ({
          ...pre,
          count: res?.data?.pageInfo?.total,
          totalPages: res?.data?.pageInfo?.totalPages,
        }));
      }
    });
  };

  const getAttendanceCount = () => {
    const option = {
      method: "GET",
    };
    const url =
      apiUrl.get_leave_count +
      "?type=attendance&" +
      MainFilterHandler(filterData);
    callApi(url, option).then((res) => {
      if (res?.status === true) {
        setState((pre) => ({ ...pre, attendanceCount: res.data }));
      } else {
        toast.error(res?.message);
      }
    });
  };

  const topViewItems = [
    { label: "Present", value: state?.attendanceCount?.present },
    { label: "Absent", value: state?.attendanceCount?.absent },
    { label: "Leaves", value: state?.attendanceCount?.leaves },
    // { label: "Half Day", value: state?.attendanceCount?.halfDay },
    { label: "Pending", value: state?.attendanceCount?.pending },
    { label: "Pending Leave", value: state?.attendanceCount?.pendingLeave },
    { label: "Pending AR", value: state?.attendanceCount?.pendingAR },
    { label: "Pending OD", value: state?.attendanceCount?.pendingOD },
  ];

  useEffect(() => {
    getMyAttendance();
  }, [
    pageStates?.sortByDate,
    pageStates?.currentPage,
    pageStates?.attendanceStatus,
    pageStates.pageSize,
    id,
    filterDetails?.orderBy,
  ]);

  useEffect(() => {
    if (!id) {
      getAttendanceCount();
    }
  }, [filterData?.sortByDate, id]);

  const singleDateChangeHandler = (date) => {
    if (!date || !moment(date).isValid()) return;

    const selectedStartDate = moment(date)
      .startOf("month")
      .format("YYYY-MM-DD");
    const selectedEndDate = moment(date).endOf("month").format("YYYY-MM-DD");

    // printData(selectedStartDate, selectedEndDate);

    setPageStates((prevState) => ({
      ...prevState,
      sortByDate: [selectedStartDate, selectedEndDate],
    }));
    setFilterData((prevState) => ({
      ...prevState,
      sortByDate: [selectedStartDate, selectedEndDate],
    }));
  };

  const attendanceStatus = [
    { value: "", label: "All" },
    { value: 1, label: "Present" },
    { value: 0, label: "Absent" },
    { value: 2, label: "Pending" },
    { value: 3, label: "On Leave" },
  ];

  const handleData = (data) => {
    // console.log(data);
    setPageStates((pre) => ({
      ...pre,
      attendanceStatus: data?.attendanceStatus,
    }));
  };

  const handleExport = () => {
    let data = {
      exportDataType: "attendanceSummary",
      ...pageStates,
    };
    ExportDataHandler(data);
  };

  const orderByHandler = (e) => {
    dispatch(
      updateFiltersStates({
        orderBy: e.target.value,
      }),
    );
  };

  const orderByList = [
    { value: "", name: "Newest" },
    { value: "asc", name: "Oldest" },
  ];

  // console.log("my attendance=========>",state?.attendanceList);

  return (
    <>
      <div className="content">
        <MainHeading
          title={`${id ? location?.state?.data?.name : ""} Attendance`}
          singleDateChangeHandler={id ? null : singleDateChangeHandler}
          showDefaultDate={true}
          pageState={{
            sortBySingleDate: pageStates?.sortByDate,
          }}
          pickerType="month"
          showBackButton={id ? true : false}
        />
        {!id && <TopLable items={topViewItems} />}
        <div className="card mb-4">
          <div className="card-body">
            <FilterComponent
              attendanceList={id ? null : attendanceStatus}
              handleFilterForAttendance={handleData}
              orderByHandler={!id ? orderByHandler : null}
              orderByList={!id ? orderByList : null}
              // handleExport={
              //   id && state?.attendanceList?.length > 0 ? handleExport : null
              // }
            />
            <div className="manage-table main-table table-responsive">
              <table className="table table-border-bottom align-middle nowrap w-100">
                <thead className="table">
                  <tr>
                    <th>#</th>
                    <th>Date</th>
                    <th>Shift</th>
                    <th>Check In</th>
                    <th>Check Out</th>
                    <th>Working Hours</th>
                    <th>Work Type</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody
                  className={pageStates?.tableLoader ? "loading-skeleton" : ""}
                >
                  {pageStates?.tableLoader ? (
                    <>
                      {[1, 2, 3].map((item, index) => (
                        <tr key={`skeleton-${index}`}>
                          {[1, 2, 3, 4, 5, 6, 7, 8]?.map((action, key) => (
                            <td key={`skeleton-cell-${key}`}>
                              <div className="">....</div>
                            </td>
                          ))}
                        </tr>
                      ))}
                    </>
                  ) : state?.attendanceList?.length > 0 ? (
                    state.attendanceList?.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item?.attendanceDate}</td>
                        <td>{item?.shift}</td>
                        <td>{item?.checkInTime}</td>
                        <td>{item?.checkOutTime}</td>
                        <td>{item?.workingHours}</td>
                        <td>{item?.workType}</td>
                        <td>{handleAttendanceStatus(item?.attendanceStatus)}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td className="text-center border-0" colSpan="12">
                        <div className="d-flex flex-column justify-colmn-center align-items-center no-data-error">
                          <NoRecordIcon />
                          {"No record found"}
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
